<template>
  <a-modal
    v-model="show"
    :centered="true"
    :keyboard="false"
    :footer="null"
    :width="500"
    @cancel="handleCancleClick"
    title="修改系统名称">
    <a-form :form="form">
        <a-form-item label='系统名称' v-bind="formItemLayout">
            <a-input v-model="systemName" v-decorator="['systemName',{rules: [{ required: true, message: '系统名称不能为空'},{ max: 15, message: '长度不能超过15个字符'}]}]"/>
        </a-form-item>
        <a-form-item label='' v-bind="formItemLayout">
          <a-row>
            <a-col :span="2" :offset="23">
              <a-button @click="handleSubmit" type="primary">确定</a-button>
            </a-col>
          </a-row>
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 }
}
import {mapState} from 'vuex'
export default {
  name: 'systemName',
  data () {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      validateStatus: '',
      help: '',
      systemName: ''
    }
  },
  props: {
    nameVisiable: {
      default: false,
      type: Boolean
    },
  },
  computed: {
    show: {
      get: function () {
        return this.nameVisiable
      },
      set: function () {
      }
    },
    ...mapState({
      user: state => state.account.user
    }),
  },
  watch: {
    nameVisiable () {
        if (this.nameVisiable) {
            this.systemName = this.$db.get('systemName')
            this.form.getFieldDecorator('systemName')
            this.form.setFieldsValue({'systemName': this.systemName})
        }
    } 
  },
  methods: {
    handleSubmit () {
        this.form.validateFields((err, values) => {
        if (!err) {
          // return
          this.$post('user/updateSystemInfo', {
            id: this.user.tenantId,
            systemName: this.systemName
          }).then((r) => {
            this.reset()
            this.$emit('success', this.systemName)
          }).catch(() => {
            // this.reset()
            console.log(11)
          })
        }
      })
    },
    handleCancleClick () {
      this.reset()
      this.$emit('close')
    },
    reset () {
      this.form.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/systemname/systemName.vue